export const getWidth = (selector: string): number => {
    const el = document.querySelector(selector);
    return el ? el.clientWidth : 0;
};
